import React, { ChangeEvent } from 'react';
import classNames from 'classnames';
import { functionNoop } from 'src/utils/function/noop';

export const Checkbox = ({
  className,
  id,
  inputProps,
  label,
  error,
  labelClassName,
  checked,
  disabled,
  isBedrock,
  onChange = functionNoop,
}: {
  className?: string;
  id?: string;
  inputProps?: Omit<JSX.IntrinsicElements['input'], 'checked' | 'onChange'>;
  label?: string;
  error?: string | false | null;
  labelClassName?: string;
  checked?: boolean;
  disabled?: boolean;
  isBedrock?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}) => {
  return (
    <label
      className={classNames('flex items-center text-bedrock-p', className, {
        'hover:opacity-80 cursor-pointer': !disabled,
        'opacity-40': disabled,
      })}
    >
      <input
        id={id}
        type='checkbox'
        className={classNames('h-4 w-4 rounded focus:ring-0 focus:ring-offset-0 cursor-pointer', {
          'border-2 border-bedrock-black text-bedrock-black': isBedrock && checked,
          'border-2 border-bedrock-gray-medium': isBedrock && !checked
        })}
        {...inputProps}
        checked={checked}
        disabled={disabled}
        onChange={(event) => {
          onChange(event, event.currentTarget.checked);
        }}
      />
      {label && <div className={classNames('ml-2', labelClassName)}>{label}</div>}
      {error && <p className='mt-2 text-sm text-bedrock-red'>{error}</p>}
    </label>
  );
};
